export { default as Divider } from './component';